module.exports = __webpack_public_path__ + "img/money-simple-from-bracket.5ae3d708.svg";